import { Injectable } from '@angular/core';
import { errorMessagesFactory } from '@app/shared/errors/error-messages-factory';
import { ErrorModel } from '@app/shared/errors/error.models';
import { TranslateService } from '@app/shared/translate/translate.service';
import { ObjectUtils } from '@app/shared/utilities/object.utils';

@Injectable({ providedIn: 'root' })
export class ErrorTranslationService {

	private errorMessages: ReturnType<typeof errorMessagesFactory>;

	constructor (
		private readonly translateService: TranslateService
	) {
		this.errorMessages = errorMessagesFactory(this.translateService.getAppLanguage());
	}

	translateError (error: ErrorModel): void {
		const metadata = ObjectUtils.parseMetadata(error.metadata);
		const errorMessage = this.errorMessages[error.errorCode];

		if (!errorMessage) {
			return;
		}

		error.message = errorMessage.message(metadata);
	}
}